module.exports = __webpack_public_path__ + "static/media/foyer-slider.ba337db6.jpg";